import mitt, { type Emitter } from 'mitt';

export {EventBus}

type Events = {
  chatmessage:Object,
  open:string
  };
const EventBus = mitt()

